import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie'
Vue.use(Vuex)
const store = new Vuex.Store({
    state:{
        /*
            考试计分题题型
            100 单选
            101 多选
            102 判断
            204 填空
            206 简答题
            207 多项填空
            208 横向填空
            209 绘图题
            210 上传文件
            211 上传图片
        */
        examQuestionTypeArr: [100, 101, 102, 204, 206, 207, 208, 209, 210, 211], 
        examQuesTypeArr: [{
                value: 100,
                label: '单选'
            },{
                value: 101,
                label: '多选'
            },{
                value: 102,
                label: '判断'
            },{
                value: 204,
                label: '填空'
            },{
                value: 206,
                label: '简答题'
            },{
                value: 207,
                label: '多项填空'
            },{
                value: 208,
                label: '横向填空'
            },{
                value: 209,
                label: '绘图题'
            },{
                value: 210,
                label: '上传文件'
            },{
                value: 211,
                label: '上传图片'
        }], 
        /**
         * @description 问卷计分题题型
         * 
         */
        wjQuestionTypeArr: ['2', '3', '4', '5', '35', '8', '10', '12', '9', '6', '11', '13', '14', '15', '16', '17', '19', '20', '21', '22', '33','34','36','37','38','39'],
        citableQuesList: [],
        htmlEditor: sessionStorage.getItem('htmlEditor') || '',
        headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        // 考试提交后回显的对象
        examAnswer: {},
        activeInputId: null, // 当前激活的输入框ID
        inputStates: {} // 所有输入框的状态
    },
    getters: {
    },
    mutations:{
        setAxamAnswer(state, data) {
            state.examAnswer = data
        },
        setCitableQuesList(state, payload) {
            state.citableQuesList = JSON.stringify(payload)
            sessionStorage.setItem('citableQuesList', JSON.stringify(payload))
        },
        removeCitableQuesList(state) {
            state.citableQuesList = []
            sessionStorage.removeItem('citableQuesList')
        },
        setHtmlEditor(state, payload) {
            state.htmlEditor = payload
            sessionStorage.setItem('htmlEditor', payload)
        },
        removeHtmlEditor(state) {
            state.htmlEditor = ''
            sessionStorage.removeItem('htmlEditor')
        },
        SET_ACTIVE_INPUT(state, id) {
            state.activeInputId = id
        },
        RESET_ALL_INPUTS(state) {
            state.activeInputId = null
            state.inputStates = {}
        },
    },
    actions: {
        setActiveInput({ commit, state }, id) {
            // 先重置所有状态
            if (state.activeInputId && state.activeInputId !== id) {
                commit('RESET_ALL_INPUTS')
            }
            // 设置新的激活输入框
            commit('SET_ACTIVE_INPUT', id)
        }
    }
})
export default store